export type PageType =
  | 'services'
  | 'solutions'
  | 'smart-ventilation'
  | 'iot-air-quality-monitoring'
  | 'engineering'
  | 'software-development'
  | 'ot-cybersecurity'
  | 'ot-awareness-training'
  | 'test-equipment-modernization'
  | 'projects'
  | 'about'
  | 'contact'
  | 'privacy'
  | 'terms-of-use'
  | 'legal-notice'
  | 'rental-terms'
  | 'articles'
  | 'A0001'
  | 'A0002'
  | 'A0003'
  | 'applications'
  | 'scygate'
  | 'dathascy'
  | 'software'
  | 'technology'
  | 'products'
  | 'v100-eco'
  | 'cart'
  | 'checkout'
  | 'finished'
  | 'login'
  | 'order'
  | 'orders'

export function translateHref(
  currentLocale: string | string[],
  page: PageType
) {
  switch (page) {
    case 'login':
      return `/${currentLocale}/${currentLocale === 'de' ? 'login' : 'login'}/`
    case 'services':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen' : 'services'}/`
    case 'solutions':
      return `/${currentLocale}/${currentLocale === 'de' ? 'loesungen' : 'solutions'}/`
    case 'smart-ventilation':
      return `/${currentLocale}/${currentLocale === 'de' ? 'loesungen/intelligente-belueftung' : 'solutions/smart-ventilation'}/`
    case 'iot-air-quality-monitoring':
      return `/${currentLocale}/${currentLocale === 'de' ? 'loesungen/iot-zustandsueberwachung/luftqualitaet' : 'solutions/iot-condition-monitoring/air-quality'}/`
    case 'engineering':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen/technische-dienstleistungen' : 'services/engineering'}/`
    case 'software-development':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen/software-entwicklung' : 'services/software-development'}/`
    case 'ot-cybersecurity':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen/ot-cybersecurity' : 'services/ot-cybersecurity'}/`
    case 'ot-awareness-training':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen/ot-awareness-training' : 'services/ot-awareness-training'}/`
    case 'test-equipment-modernization':
      return `/${currentLocale}/${currentLocale === 'de' ? 'dienstleistungen/test-equipment-modernization' : 'services/test-equipment-modernization'}/`
    case 'projects':
      return `/${currentLocale}/${currentLocale === 'de' ? 'projekte' : 'projects'}/`
    case 'applications':
      return `/${currentLocale}/${currentLocale === 'de' ? 'anwendungen' : 'applications'}/`
    case 'software':
      return `/${currentLocale}/${currentLocale === 'de' ? 'software' : 'software'}/`
    case 'dathascy':
      return `/${currentLocale}/${currentLocale === 'de' ? 'software/dathascy' : 'software/dathascy'}/`
    case 'products':
      return `/${currentLocale}/${currentLocale === 'de' ? 'produkte' : 'products'}/`
    case 'cart':
      return `/${currentLocale}/${currentLocale === 'de' ? 'warenkorb' : 'cart'}/`
    case 'checkout':
      return `/${currentLocale}/${currentLocale === 'de' ? 'kasse' : 'checkout'}/`
    case 'finished':
      return `/${currentLocale}/${currentLocale === 'de' ? 'kasse/finished' : 'checkout/finished'}/`
    case 'v100-eco':
      return `/${currentLocale}/${currentLocale === 'de' ? 'produkte/v100-eco' : 'products/v100-eco'}/`
    case 'scygate':
      return `/${currentLocale}/${currentLocale === 'de' ? 'products/smart_sensors/scygate' : 'products/smart_sensors/scygate'}/`
    case 'about':
      return `/${currentLocale}/${currentLocale === 'de' ? 'unternehmen' : 'about'}/`
    case 'contact':
      return `/${currentLocale}/${currentLocale === 'de' ? 'kontakt' : 'contact'}/`
    case 'privacy':
      return `/${currentLocale}/${currentLocale === 'de' ? 'datenschutz' : 'privacy'}/`
    case 'terms-of-use':
      return `/${currentLocale}/${currentLocale === 'de' ? 'terms-of-use' : 'terms-of-use'}/`
    case 'legal-notice':
      return `/${currentLocale}/${currentLocale === 'de' ? 'impressum' : 'legal-notice'}/`
    case 'rental-terms':
      return `/${currentLocale}/${currentLocale === 'de' ? 'rental-terms' : 'rental-terms'}/`
    case 'articles':
      return `/${currentLocale}/${currentLocale === 'de' ? 'artikel' : 'articles'}/`
    case 'A0001':
      return `/${currentLocale}/${currentLocale === 'de' ? 'artikel/bedeutung-der-maschinendatenerfassung' : 'articles/importance-of-machine-data-collection'}/`
    case 'A0002':
      return `/${currentLocale}/${currentLocale === 'de' ? 'artikel/herausforderungen-bei-der-maschinendatenerfassung' : 'articles/challenges-in-machine-data-collection'}/`
    case 'A0003':
      return `/${currentLocale}/${currentLocale === 'de' ? 'artikel/mehrwert-einer-guten-datenueberwachungsschnittstelle' : 'articles/added-value-of-a-good-data-monitoring-interface'}/`
    case 'technology':
      return `/${currentLocale}/${currentLocale === 'de' ? 'technologie' : 'technology'}/`
    case 'order':
      return `/${currentLocale}/${currentLocale === 'de' ? 'order' : 'order'}/`
    case 'orders':
      return `/${currentLocale}/${currentLocale === 'de' ? 'orders' : 'orders'}/`
  }
}
